export default __webpack_public_path__ + "static/media/add-user.dd3bb183.svg";